// extracted by mini-css-extract-plugin
export default {"subTitle":"bpm6CO7N1dJ8w75k_0w8"};